import React, { useState } from "react";
import PageHeader from "../components/common/PageHeader";
import MetaData from "../helpers/MetaData";
import { useForm } from "react-hook-form";
import notification from "../helpers/notification";
import ApiService from "../api/ApiService";
import { useNavigate } from "react-router-dom";

const DamodarDarshan = () => {
    const [loading, setLoading] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const navigate = useNavigate();
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm();

    const handleRegistration = async (values) => {
        try {
            setLoading(true);
            console.log(values);

            const res = await ApiService.registerDamodarDarshan(values);

            notification("success", "Registration successful! We will contact you soon.");
            reset();
            setLoading(false);
            setShowSuccess(true);

            window.scrollTo({ top: 0, behavior: 'smooth' });

        } catch (error) {
            setLoading(false);
            console.log(error);
            notification("error", error.response?.data?.message || "Registration failed");
        }
    };

    const ageOptions = [8, 9, 10, 11, 12, 13];

    if (showSuccess) {
        return (
            <>
                <MetaData title="Registration Successful - Damodar Darshan" />
                <section className="registration-success-section" style={{ marginTop: '100px', minHeight: '70vh' }}>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-8 text-center">
                                <div className="success-icon mb-4">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="100"
                                        height="100"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="#22c55e"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                        <polyline points="22 4 12 14.01 9 11.01"></polyline>
                                    </svg>
                                </div>
                                <h2 className="mb-4" style={{ color: '#1E3A8A', fontSize: '2.5rem' }}>
                                    Hare Krishna! 🙏
                                </h2>
                                <div style={{
                                    background: '#D1FAE5',
                                    border: '3px solid #10B981',
                                    borderRadius: '15px',
                                    padding: '30px',
                                    marginBottom: '30px'
                                }}>
                                    <h3 style={{ color: '#065F46', marginBottom: '20px' }}>
                                        Thank You for Registering! ✨
                                    </h3>
                                    <p className="lead" style={{ color: '#064E3B', fontSize: '1.2rem', marginBottom: '15px' }}>
                                        Your child has been successfully registered for the <strong>Damodar Darshan</strong> program.
                                    </p>
                                    <p style={{ color: '#065F46', fontSize: '1.1rem' }}>
                                        We will contact you soon with the Zoom meeting details and further instructions.
                                    </p>
                                </div>

                                <div style={{
                                    background: '#FEF3C7',
                                    border: '2px solid #F59E0B',
                                    borderRadius: '12px',
                                    padding: '20px',
                                    marginBottom: '30px'
                                }}>
                                    <h4 style={{ color: '#92400E', marginBottom: '15px' }}>📋 What's Next?</h4>
                                    <ul style={{
                                        listStyle: 'none',
                                        padding: 0,
                                        color: '#78350F',
                                        textAlign: 'left',
                                        maxWidth: '500px',
                                        margin: '0 auto'
                                    }}>
                                        <li style={{ marginBottom: '10px', fontSize: '1rem' }}>
                                            ✓ You will be added to our WhatsApp group
                                        </li>
                                        <li style={{ marginBottom: '10px', fontSize: '1rem' }}>
                                            ✓ Zoom links will be shared every Saturday & Sunday
                                        </li>
                                        <li style={{ marginBottom: '10px', fontSize: '1rem' }}>
                                            ✓ First session starts on 11th October
                                        </li>
                                        <li style={{ marginBottom: '10px', fontSize: '1rem' }}>
                                            ✓ Remember: 95% attendance needed for prizes! 🎁
                                        </li>
                                    </ul>
                                </div>

                                <div style={{
                                    background: 'linear-gradient(135deg, #DDD6FE 0%, #FBCFE8 100%)',
                                    borderRadius: '12px',
                                    padding: '20px',
                                    marginBottom: '30px'
                                }}>
                                    <p style={{ color: '#581C87', fontSize: '1.1rem', marginBottom: '10px' }}>
                                        📞 For any queries, contact us at:
                                    </p>
                                    <p style={{ fontSize: '1.3rem', fontWeight: 'bold', color: '#6B21A8' }}>
                                        <a href="tel:9390484376" style={{ color: '#6B21A8', textDecoration: 'none' }}>
                                            9390484376
                                        </a>
                                    </p>
                                </div>

                                <button
                                    onClick={() => {
                                        setShowSuccess(false);
                                        window.scrollTo({ top: 0, behavior: 'smooth' });
                                    }}
                                    style={{
                                        background: 'linear-gradient(135deg, #EA580C 0%, #DC2626 100%)',
                                        color: 'white',
                                        border: 'none',
                                        padding: '12px 40px',
                                        fontSize: '1.1rem',
                                        fontWeight: 'bold',
                                        borderRadius: '50px',
                                        cursor: 'pointer',
                                        boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
                                        marginRight: '10px'
                                    }}
                                >
                                    Register Another Child
                                </button>

                                <button
                                    onClick={() => navigate('/')}
                                    style={{
                                        background: 'white',
                                        color: '#DC2626',
                                        border: '2px solid #DC2626',
                                        padding: '12px 40px',
                                        fontSize: '1.1rem',
                                        fontWeight: 'bold',
                                        borderRadius: '50px',
                                        cursor: 'pointer',
                                        marginTop: '10px'
                                    }}
                                >
                                    Go to Home
                                </button>

                                <p style={{
                                    marginTop: '30px',
                                    fontStyle: 'italic',
                                    color: '#666',
                                    fontSize: '0.95rem'
                                }}>
                                    Hare Krishna Hare Krishna Krishna Krishna Hare Hare<br />
                                    Hare Rama Hare Rama Rama Rama Hare Hare
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        );
    }

    return (
        <>
            <MetaData title="Damodar Darshan Registration - ISKCON Attapur" />
            <section className="donation-form-sec" style={{ marginTop: '100px' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 mx-auto">
                            <div className="heading">
                                <h2 className="head-1">Damodar Darshan – Online Spiritual Adventure</h2>
                                <p className="b-line">
                                    Join this Kartik for a joyful and enlightening online journey designed especially
                                    for children aged <strong>8 to 13 years</strong>!
                                </p>
                            </div>

                            <div className="quiz-details mt-4">
                                <p>✨🌸 <strong>Hare Krishna!</strong> 🌸✨</p>
                                <p>
                                    <strong>KRISHNA KARNAMRITAM</strong> is back with another
                                    <em> Online Spiritual Adventure 🌟</em>! We're overjoyed to invite your little Krishna devotee to join our
                                    <strong> "Damodar Darshan" </strong> program — carefully crafted for young hearts to grow in Krishna consciousness.
                                </p>

                                <h4>🗓️ Program Schedule</h4>
                                <ul>
                                    <li><strong>Dates:</strong> 11<sup>th</sup> October – 10<sup>th</sup> November</li>
                                    <li><strong>Days & Time:</strong> Saturdays (5 PM – 6 PM) and Sundays (4 PM – 5:30 PM)</li>
                                    <li><strong>Mode:</strong> Online via Zoom (in English)</li>
                                </ul>

                                <h4>🌼 Highlights</h4>
                                <ul>
                                    <li>Heartwarming sessions on <strong>Damodarastakam</strong> & <strong>Bhagavad Gita</strong></li>
                                    <li>Captivating stories and fun, devotional activities</li>
                                    <li>A loving community of young devotees to connect with</li>
                                </ul>

                                <p>
                                    🎁 <strong>Special Gift:</strong> Children with 95% attendance will receive a surprise gift blessed by Lord Krishna!
                                </p>

                                <h4>📢 Register Now!</h4>

                                <p>
                                    📞 <strong>Contact:</strong> <a href="tel:9390484376">9390484376</a>
                                </p>

                                <p className="mt-3">
                                    Let's come together to celebrate the love of Krishna and share this blissful experience! 🙏❤️
                                </p>

                                <p><strong>Warm regards,</strong><br />Team Krishna Karnamritam</p>
                            </div>
                        </div>
                    </div>

                    <form className="shop-form mt-5" onSubmit={handleSubmit(handleRegistration)}>
                        <div className="row align-items-center">
                            <div className="col-lg-4">
                                <div className="donate-img">
                                    <figure className="mb-0">
                                        <img src="/images/common/krishna-damodarastakam.jpg" alt="Damodar Darshan" />
                                    </figure>
                                </div>
                            </div>
                            <div className="col-lg-8 mt-lg-0 mt-4">
                                <div style={{
                                    background: 'white',
                                    borderRadius: '15px',
                                    padding: '30px',
                                    boxShadow: '0 5px 20px rgba(0,0,0,0.1)'
                                }}>
                                    <h3 style={{
                                        textAlign: 'center',
                                        background: 'linear-gradient(135deg, #DC2626 0%, #EA580C 100%)',
                                        WebkitBackgroundClip: 'text',
                                        WebkitTextFillColor: 'transparent',
                                        fontSize: '2rem',
                                        marginBottom: '10px'
                                    }}>
                                        FREE!! Register Now
                                    </h3>
                                    <p style={{ textAlign: 'center', color: '#666', marginBottom: '25px' }}>
                                        Fill in the details below to register your child
                                    </p>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-part">
                                                <label htmlFor="childName">Name of the Child <span style={{ color: 'red' }}>*</span></label>
                                                <input
                                                    type="text"
                                                    placeholder="Enter child's full name"
                                                    {...register("childName", { required: "Child's name is required" })}
                                                />
                                                {errors.childName && (
                                                    <span className="error text-danger">{errors.childName.message}</span>
                                                )}
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-part">
                                                <label htmlFor="age">Age <span style={{ color: 'red' }}>*</span></label>
                                                <select
                                                    {...register("age", { required: "Age is required" })}
                                                    style={{
                                                        width: '100%',
                                                        padding: '10px',
                                                        border: '1px solid #ddd',
                                                        borderRadius: '5px',
                                                        fontSize: '1rem'
                                                    }}
                                                >
                                                    <option value="">Select age</option>
                                                    {ageOptions.map(age => (
                                                        <option key={age} value={age}>{age} years</option>
                                                    ))}
                                                </select>
                                                {errors.age && (
                                                    <span className="error text-danger">{errors.age.message}</span>
                                                )}
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-part">
                                                <label>Gender <span style={{ color: 'red' }}>*</span></label>
                                                <div style={{ display: 'flex', gap: '20px', paddingTop: '10px' }}>
                                                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                                                        <input
                                                            type="radio"
                                                            value="Male"
                                                            {...register("gender", { required: "Gender is required" })}
                                                            style={{ width: '18px', height: '18px' }}
                                                        />
                                                        <span>Male</span>
                                                    </label>
                                                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                                                        <input
                                                            type="radio"
                                                            value="Female"
                                                            {...register("gender", { required: "Gender is required" })}
                                                            style={{ width: '18px', height: '18px' }}
                                                        />
                                                        <span>Female</span>
                                                    </label>
                                                </div>
                                                {errors.gender && (
                                                    <span className="error text-danger">{errors.gender.message}</span>
                                                )}
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-part">
                                                <label htmlFor="city">City of Residence <span style={{ color: 'red' }}>*</span></label>
                                                <input
                                                    type="text"
                                                    placeholder="Enter your city"
                                                    {...register("city", { required: "City is required" })}
                                                />
                                                {errors.city && (
                                                    <span className="error text-danger">{errors.city.message}</span>
                                                )}
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            <div className="form-part">
                                                <label htmlFor="contactNumber">Contact Number <span style={{ color: 'red' }}>*</span></label>
                                                <input
                                                    type="tel"
                                                    placeholder="Enter 10-digit mobile number"
                                                    maxLength={10}
                                                    onKeyPress={(event) => {
                                                        if (!/[0-9]/.test(event.key)) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                    {...register("contactNumber", {
                                                        required: "Contact number is required",
                                                        pattern: {
                                                            value: /^[6-9]\d{9}$/,
                                                            message: "Please enter a valid 10-digit mobile number",
                                                        },
                                                    })}
                                                />
                                                {errors.contactNumber && (
                                                    <span className="error text-danger">{errors.contactNumber.message}</span>
                                                )}
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            <button
                                                type="submit"
                                                className="box-hover custom-btn-cls donation_btn ms-0"
                                                style={{
                                                    background: 'linear-gradient(135deg, #EA580C 0%, #DC2626 100%)',
                                                    width: '100%',
                                                    padding: '15px',
                                                    fontSize: '1.2rem',
                                                    fontWeight: 'bold',
                                                    marginTop: '20px'
                                                }}
                                            >
                                                {loading ? (
                                                    <div className="d-flex align-items-center justify-content-center">
                                                        <div className="spinner-border text-light" role="status"></div>
                                                        <div className="ms-2">REGISTERING...</div>
                                                    </div>
                                                ) : (
                                                    "REGISTER NOW - FREE"
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
        </>
    );
};

export default DamodarDarshan;